import { useCallback, useRef, useState } from 'react';

// Trava de clique duplo para quem dispara envio a portal.
//
// O `disabled` sozinho não basta: dois cliques no mesmo tick chegam antes do
// re-render que desabilitaria o botão. A trava é o ref, que muda na hora; o
// estado só serve para a tela mostrar que está ocupada.
//
// `executar` devolve o que a função devolveu, ou `undefined` quando o clique
// foi descartado por já haver um em andamento.
export function useTravaDeEnvio() {
  const travado = useRef(false);
  const [ocupado, setOcupado] = useState(false);

  const executar = useCallback(async <T,>(fn: () => Promise<T>): Promise<T | undefined> => {
    if (travado.current) return undefined;
    travado.current = true;
    setOcupado(true);
    try {
      return await fn();
    } finally {
      travado.current = false;
      setOcupado(false);
    }
  }, []);

  return { ocupado, executar };
}
